import React from "react";
import { Link } from "react-router-dom";
import "../Properties/PropertiesList.css";
import BathIcon from "../Assets/Images/bath_icon.svg";
import BedIcon from "../Assets/Images/bed_icon.svg";

// Function to calculate the time difference
const isJustAdded = (createDate) => {
  const createdAt = new Date(createDate);
  const now = new Date();
  const timeDifference = now - createdAt; // Difference in milliseconds
  const daysDifference = timeDifference / (1000 * 3600 * 24); // Convert to days
  return daysDifference <= 7; // Returns true if within 7 days
};

function PropertiesList({
  price,
  address_1,
  address_2,
  images,
  county,
  town,
  postcode_1,
  bedrooms,
  bathrooms,
  property_ref,
  status_id,
  create_date,
}) {
  console.log("Property Ref in Link:", property_ref);
  console.log("Create Date:", create_date);  // Log create_date to see its value
  console.log("Is Just Added:", isJustAdded(create_date)); 

  return (
    <div className="propertiesCardContainer">
      <h5>Property Ref: {property_ref}</h5> {/* Display the property_ref */}
      <Link
        to={`/property-details/${property_ref}`}
        className="propertyListCardLink"
      >
        <div className="propertyCardImage">
          {Array.isArray(images) && images.length > 0 ? (
            <img src={images[0].url} alt={images[0].text || "Property Image"} />
          ) : (
            <div className="noImagePlaceholder">No Image Available</div>
          )}

          {/* "Just Added" Label */}
          {isJustAdded(create_date) && (
            <div className="propertyCardLabel">Just Added</div>
          )}

          {(status_id === 7 ||
            status_id === 6 ||
            status_id === 5 ||
            status_id === 1) && (
            <div className="propertyCardLabel">
              {status_id === 7 && "Let"}
              {status_id === 6 && "Sold"}
              {status_id === 5 && "Let Agreed"}
              {status_id === 1 && "SSTC"}
            </div>
          )}
        </div>
        <div className="propertyCardInfo">
          <h4 className="propertyCardPrice">£{price.toLocaleString()}</h4>
          <p className="propertyCardLocation">
            {[
              address_1
                ?.replace(/\b(Flat|Apt|Apartment)\s*\d*[A-Za-z]?\b/gi, "")
                .replace(/^\d+[A-Za-z]?\s*/, "")
                .trim(),
              address_2,
              town && !county ? town : county, // Show town if available, otherwise show county
              postcode_1,
            ]
              .filter(Boolean)
              .join(", ")
              .replace(/^,\s*/, "")}{" "}
            {/* Remove leading comma */}
          </p>

          <div className="propertyCardDetails">
            <span>
              {bedrooms}
              <img className="propertyCardIcons" src={BedIcon} alt="Bed Icon" />
            </span>
            <span>
              {bathrooms}
              <img
                className="propertyCardIcons"
                src={BathIcon}
                alt="Bath Icon"
              />
            </span>
          </div>
        </div>
      </Link>
    </div>
  );
}

export default PropertiesList;
